import { PAGE_PATH_SALES_AGENT } from '@bluheadless/ui-logic/src/constants'
import { useSalesAgent } from '@bluheadless/ui-logic/src/providers/sales-agent'
import { cx } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import Typography from '../../atoms/typography/typography'
import Link from '../../molecules/link/link'
import { Root } from './sales-agent-notice.styled'

const SalesAgentNotice = () => {
	const [{ isLoggedIn }] = useSalesAgent()

	return isLoggedIn ? (
		<Root className={cx('SalesAgentNotice-root')}>
			<Link href={PAGE_PATH_SALES_AGENT}>
				<Typography align="center" variant="body2">
					<FormattedMessage id="sales_agent_notice" />
				</Typography>
			</Link>
		</Root>
	) : null
}

export default SalesAgentNotice
